<div class="legend-config-map">
    <button class="btn-close-dialog" (click)="cancel()" title="Cerrar">
        <i class="fa-light fa-xmark"></i>
    </button>
    <div class="main-legend-config">
        <h1 class="title-legend-config">Configurar leyenda del mapa</h1>
        <p class="subtitle">Elige qué información mostrar en la leyenda que verá el comprador y personaliza
            las etiquetas. Los nombres y colores de las zonas y bloqueos se toman automáticamente del mapa.</p>

        <!-- Estados de las butacas -->
        <div class="legend-section">
            <p class="legend-section-title">Estados de las butacas</p>

            <div class="legend-row" *ngFor="let key of ['available','selected','occupied']">
                <mat-checkbox [(ngModel)]="config.states[key].show" color="primary"></mat-checkbox>
                <input type="text" class="legend-label-input" [(ngModel)]="config.states[key].label"
                    maxlength="40" placeholder="Etiqueta" [disabled]="!config.states[key].show">
            </div>
        </div>

        <mat-divider></mat-divider>

        <!-- Zonas de precio -->
        <div class="legend-section">
            <div class="legend-row">
                <mat-checkbox [(ngModel)]="config.levels.show" color="primary"></mat-checkbox>
                <input type="text" class="legend-label-input" [(ngModel)]="config.levels.label"
                    maxlength="40" placeholder="Zonas de precio" [disabled]="!config.levels.show">
            </div>
            <div class="legend-preview" *ngIf="config.levels.show && levels.length > 0">
                <p class="legend-preview-hint">Se mostrará una fila por nivel:</p>
                <div class="legend-preview-item" *ngFor="let level of levels">
                    <div class="legend-preview-color" [style.background-color]="level.color"></div>
                    <span>{{ level.name }}</span>
                </div>
            </div>
        </div>

        <mat-divider></mat-divider>

        <!-- Bloqueos / reservados -->
        <div class="legend-section">
            <div class="legend-row">
                <mat-checkbox [(ngModel)]="config.blockedGroups.show" color="primary"></mat-checkbox>
                <input type="text" class="legend-label-input" [(ngModel)]="config.blockedGroups.label"
                    maxlength="40" placeholder="Reservado" [disabled]="!config.blockedGroups.show">
            </div>
            <p class="legend-preview-hint" *ngIf="config.blockedGroups.show">
                Se mostrará una fila por grupo de bloqueo del evento, con su nombre y color reales.
            </p>
        </div>

        <mat-divider></mat-divider>

        <!-- Comportamiento -->
        <div class="legend-section">
            <div class="legend-row">
                <mat-checkbox [(ngModel)]="config.defaultOpen" color="primary"></mat-checkbox>
                <span class="legend-behavior-label">Mostrar la leyenda abierta por defecto</span>
            </div>
        </div>
    </div>
    <mat-divider></mat-divider>
    <div class="footer-legend-config">
        <div class="btn-new btn-create btn-create-border m-0" (click)="reset()" *ngIf="hadConfig"
            title="Volver a la leyenda por defecto">
            <p class="m-0">Restablecer</p>
        </div>
        <div class="btn-new btn-create btn-create-border m-0" (click)="cancel()">
            <p class="m-0">Cancelar</p>
        </div>
        <div class="btn-new btn-create m-0" (click)="confirm()">
            <p class="m-0">Guardar</p>
        </div>
    </div>
</div>
